(function () {
    'use strict';

    angular.module('swif.framework')

    .factory('swifValidationService', swifValidationService);

    function swifValidationService(dataService, userService) {
        'ngInject';
        var data = dataService;
        var userSrv = userService;
        var srv = {
            cache: {
                users: {},
                usersId: 0,
            }
        };

        srv._parseItem = function (model, item, allItems) {
            // if item has choice_ids, means its a 'middle' item, linking a block with other sub blocks
            if (!_.isEmpty(item.choice_ids) || item.validation_type) {
                item.operator = item.validation_type || '';
                if (!item.items) {
                    item.items = [];
                }
            } else {
                // @TODO: ensure user_id is on the object
            }
            // finally, try to attach this item to the (parent) item having this ID on its choice_ids,
            // or under the validation Object if no choice_ids is found on items
            var parentItem = _.find(allItems, function (elt) {
                return _.include(elt.choice_ids || [], item.id);
            });
            if (parentItem) {
                if (!parentItem.items) {
                    parentItem.items = [];
                }
                parentItem.items.push(item);
            } else {
                if (!model.items) {
                    model.items = [];
                }
                model.items.push(item);
            }
        };

        srv.getObjectFromServer = function (modelId) {
            var ret = {items: []};
            if (modelId) {
                // first, retrieve the validationOrder data
                data.get('validation-order', modelId).then(function (val) {
                    _.merge(ret, val);
                    // then, retrieve ALL the sub-items attached to this validationOrder
                    // i perform only ONE call (to fluidify network) and attach
                    // the items together by parsing each element in the Array
                    ret.items = [];
                    if (val.block_id) {
                        var filter = {};
                        data.addFilter(filter, 'block_id', 'child_of', val.block_id[0]);
                        data.get('validation-block-item', undefined, filter)
                        .then(function (res) {
                            _.forEach(res, function (item) {
                                srv._parseItem(ret, item, res);
                            });
                        });
                    }
                });
            }
            return ret;
        };

        // @param forCreation (boolean): if true, remove 'choice_ids' and 'id'
        //     (a save() will result in creation of new objects),
        //     otherwise, a save() will modify the object as usual
        srv.getTemplateFromServer = function (modelId, forCreation) {
            var ret = {items: []};
            if (modelId) {
                // retrieve ALL the sub-items attached to this validationOrder
                // i perform only ONE call (to fluidify network) and attach
                // the items together by parsing each element in the Array
                var filter = {};
                data.addFilter(filter, 'block_id', 'child_of', modelId);
                data.get('validation-block-item-template', undefined, filter)
                .then(function (res) {
                    _.forEach(res, function (item) {
                        srv._parseItem(ret, item, res);
                    });
                    // choice_ids must be kept for parseItem()
                    if (forCreation) {
                        _.forEach(res, function (item) {
                            item.choice_ids = [];
                            delete item.id;
                        });
                    }
                });
            }
            return ret;
        };

        srv._prepareBlockForSave = function (model, operator, fnct) {
            var sequence = 0;
            var ret = {
                name: model.name || '',
                validation_type: operator,
                template_id: model.template_id,
                choice_ids: []
            };
            var choice_ids = data.prepareOne2manyValues(
                model.choice_ids || [],
                model.items || [],
                function (item) {
                    sequence++;
                    // compute the sub-item value based on the fnct supplied
                    var val = fnct(item);
                    val.sequence = sequence;
                    return val;
                }
            );
            ret.choice_ids = choice_ids;
            return ret;
        };

        /*
         * @param model: (Object) the model created by the swifValidationBLock* directives
         *     Must have the following synthax: {operator: 'next/or/and', items: [....], sequence: ID or null}
         *    where items may contains sub-model like this parent, but should have either items XOR user_id attribute defined
         *    it cannot have both attribute defined, else, the behavior will create sub_block and ignore user_id
         * @return: (Object) A new model, directly usable to create / update a validation record
         *   the user may only indicates which is the contentType to create with this model,
         *   and handle the link between its original model (intervention, request, etc.) with this one (validation)
        */
        srv.prepareObjectForSave = function (model) {
            var ret = {};
            if (model.items) {
                var val = srv._prepareBlockForSave(model, 'next', function (item) {
                    item.name = model.name;
                    return srv._prepareBlockForSave(item, 'and', function (subItem){
                        return srv._prepareBlockForSave(subItem, 'or', function (blockItem) {
                            var val = {
                                static_user_id: blockItem.user_id ? blockItem.user_id[0] : false,
                            };
                            if (blockItem._choice) {
                                val.state = blockItem._choice;
                                val.note = blockItem._note || '';
                                val.send_email = blockItem.send_email;
                            }
                            return val;
                        });
                    });
                });
                val.template_id = model.template_id ? model.template_id[0] : false;
                _.merge(ret, val);
            }
            return ret;
        };

        srv.hashColorItem = {};
        srv.resetColors = function (validation) {
            srv.hashColorItem[validation] = 0;
        };

        srv.getItemColor = function (valiadtion) {
            var ret = '';
            var item = srv.hashColorItem[valiadtion];
            if (item) {
                var colors = srv.getAvailableColors();
                ret = colors[srv.currentColorIndex % colors.length];
            }
            return ret;
        };

        srv.getNextColor = function (valiadtion) {
            var color = '';
            var counter = srv.hashColorItem[valiadtion];
            if (!_.isUndefined(counter)) {
                var colors = srv.getAvailableColors();
                color = colors[counter];
                srv.hashColorItem[valiadtion] = (counter + 1) % colors.length;
            }
            return color;
        };

        srv.getAvailableColors = function () {
            return ['info', 'success', 'danger'];
        };

        srv.getGroupedItems = function (model) {
            var filter = {};
            var colors = srv.getAvailableColors();
            // the key of 'items' is the block_id ID of the validation items
            var ret = {};
            if (model.block_id) {
                // i compute a domain that will retrieve ALL actives validation items
                // that rely on static_user_id (deeper level) and are children of the validation object
                data.addFilter(filter, 'sub_block_id', '=', false);
                data.addFilter(filter, 'block_id', 'child_of', model.block_id[0]);
                data.addFilter(filter, 'state', '=', 'active');
                data.get('validation-block-item', undefined, filter).then(function (data) {
                    // then, i group the validation items by their 'block_id' field,
                    // in order to colorize each 'OR' block with a different color
                    var i = 0;
                    _.forEach(data, function (item) {
                        if (item.block_id) {
                            var key = item.block_id[0];
                            if (!ret[key]) {
                                ret[key] = {color: colors[i++ % colors.length], items: []};
                            }
                            ret[key].items.push(item);
                        }
                    });
                });
            }
            return ret;
        };

        srv.getLastItem = function (model) {
            var filter = {};
            var colors = srv.getAvailableColors();
            var ret = {0: {items: [], color: colors[0]}};
            if (model.block_id) {
                data.addFilter(filter, 'block_id', 'child_of', model.block_id[0]);
                data.addFilter(filter, 'sub_block_id', '=', false);
                data.addFilter(filter, 'date', '!=', false);
                data.addFilter(filter, 'state', 'in', ['confirm', 'refuse']);
                data.setLimit(filter, 1);
                filter.sort = 'date DESC';
                data.get('validation-block-item',undefined,  filter).then(function (data) {
                    if (!_.isEmpty(data)) {
                        ret[0].items.push(data[0]);
                    }
                });
            }
            return ret;
        };

        srv.getDoneItems = function (model) {
            var filter = {};
            var ret = [];
            if (model.block_id) {
                data.addFilter(filter, 'sub_block_id', '=', false);
                data.addFilter(filter, 'block_id', 'child_of', model.block_id[0]);
                data.addFilter(filter, 'state', 'in', ['confirm', 'refuse']);
                data.get('validation-block-item', undefined, filter).then(function (data) {
                    _.forEach(data, function (item) {
                        ret.push(item);
                    });
                });
            }
            return ret;
        };

        srv.getUserBlockItem = function (model) {
            var ret = {};
            var filter = {};
            if (model.current_user_item_id) {
                data.addFilter(filter, 'choice_ids', '=', model.current_user_item_id[0]);
                data.get('validation-block', undefined, filter).then(function (data) {
                    if (!_.isEmpty(data)) {
                        _.merge(ret, data[0]);
                    }
                });
            }
            return ret;
        };

        srv.getUserItem = function (model) {
            var ret = {};
            var filter = {};
            if (model.current_user_item_id) {
                data.get('validation-block-item', model.current_user_item_id[0])
                .then(function (data) {
                    if (!_.isEmpty(data)) {
                        _.merge(ret, data[0]);
                    }
                });
            }
            return ret;
        };

        srv.getTemplateFilter = function () {
            var filter = {};
            data.addFilter(filter, 'validation_type', '=', 'next');
            return filter;
        };

        srv.initValidationModel = function (model) {
            var usr = userSrv.getAuthenticatedUserData();
            return _.defaults(model || {}, {
                creator_id: [usr.id, usr.name],
                operator: 'next',
                name: '',
                items: []
            });
        };

        srv.defaultDirective = {
            restrict: 'E',
            require: 'ngModel',
            // replace: true,
            scope: {
                operator: '@',
                readonly: '=?',
                forced: '=?',  // forced means "can't change workflow, but can change the msg"
                validationOrder: '=?',
                initialize: '=?', // whether or not we should create an empty item if no items is found on ngModel
                userFilter: '=?'  // optional filter for user selection
            },

            link: function (scope, element, attr, ngModel) {

                scope.proxy = {items: [], operator: scope.operator, name: ''};
                scope.colors = srv.getAvailableColors();
                scope.sync = function () {
                    ngModel.$setViewValue(scope.proxy);
                };
                ngModel.$render = function () {
                    var data = ngModel.$viewValue;
                    if (data) {
                        scope.proxy = data;
                        if (!scope.validationOrder && !scope.proxy.id) {
                            // when creating a new validation process, the creator is the connected user
                            // else, if createId is not supplied on directive, it won't be able to display its creator data
                            var usr = userSrv.getAuthenticatedUserData();
                            scope.validationOrder = [usr.id, usr.name];
                        }
                    }
                };
                scope.addItem = function (model) {
                    if (!model) {
                        model = {items: []};
                    }
                    scope.proxy.items.push(model);
                };

                scope.clearItem = function (item) {
                    item.items.splice(0, item.items.length);
                };

                scope.removeItem = function (model) {
                    var item = _.remove(scope.proxy.items, function (elt) {
                        return elt === model;
                    });
                    /*
                    @TODO: handle deletion of existing model on backend
                      if (item) {
                        _.forEach(item, function (toDelete) {

                        });
                    } */
                    return item;
                };
            },
            templateUrl: ''
        };
        return srv;
    }

})();
